import { FC, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePayMarketingMutation, useViewPositionMutation } from "src/redux/api/cabinet";
import { Structure } from "./Structure";
import { SkeletonComp } from "./SkeletonComp";
import { Levels } from "./Levels";
import { PaymantContainer } from "./PaymantContainer";
import { useTimer } from 'react-timer-hook';
import { useSelector } from "react-redux";
import { AppState } from "src/store/Store";
import { useDispatch } from "react-redux";
import { updActiveTimer } from "src/redux/slices/app";
import { Alerting } from "src/views/components_cabinet/Alerting";
import { StructureChain } from "./StructureChain";
import { Box, Button, Typography } from "@mui/material";
import { RightDrawer } from "./RightDrawer";
import { palette } from "src/theme/style/palette";
import { programs, Program } from "src/components/shared/constants/marketings";

interface IMyTimer {
    expiryTimestamp: Date;
    onTimerExpire: () => void;
}

const MyTimer: FC<IMyTimer> = ({ expiryTimestamp, onTimerExpire }) => {
    const dispatch = useDispatch();

    const {
        seconds,
        minutes,
        hours,
        days,
        restart,
    } = useTimer({
        expiryTimestamp,
        onExpire: () => {
            dispatch(updActiveTimer({ state: false }));
            onTimerExpire(); // Скрываем таймер и показываем контент
        }
    });

    // Перезапускаем таймер при изменении expiryTimestamp
    useEffect(() => {
        restart(expiryTimestamp);
    }, [expiryTimestamp, restart]);

    return (
        <Box style={{ minHeight: '200px' }} display='flex' justifyContent='center' alignItems='center'>
            <Box display='flex' justifyContent='center'>
                <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                    <Box sx={{
                        px: 2, py: 1,
                        borderRadius: `10px`, background: palette.infoLight
                    }}>
                        <Typography textAlign='center' sx={{ mt: .5, fontSize: '2.2rem', fontWeight: 500 }}>
                            <code>{days < 10 ? `0${days}` : days}</code>
                        </Typography>
                    </Box>
                    <Typography textAlign='center' sx={{ mt: .5, fontSize: '.8rem', fontWeight: 600 }}>
                        <code>Дн.</code>
                    </Typography>
                </Box>
                <Box mx={.5} mt={1.8}>
                    <code>:</code>
                </Box>
                <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                    <Box sx={{
                        px: 2, py: 1,
                        borderRadius: `10px`, background: palette.infoLight
                    }}>
                        <Typography textAlign='center' sx={{ mt: .5, fontSize: '2.2rem', fontWeight: 500 }}>
                            <code>{hours < 10 ? `0${hours}` : hours}</code>
                        </Typography>
                    </Box>
                    <Typography textAlign='center' sx={{ mt: .5, fontSize: '.8rem', fontWeight: 600 }}>
                        <code>Час.</code>
                    </Typography>
                </Box>
                <Box mx={.5} mt={1.8}>
                    <code>:</code>
                </Box>
                <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                    <Box sx={{
                        px: 2, py: 1,
                        borderRadius: `10px`, background: palette.infoLight
                    }}>
                        <Typography textAlign='center' sx={{ mt: .5, fontSize: '2.2rem', fontWeight: 500 }}>
                            <code>{minutes < 10 ? `0${minutes}` : minutes}</code>
                        </Typography>
                    </Box>
                    <Typography textAlign='center' sx={{ mt: .5, fontSize: '.8rem', fontWeight: 600 }}>
                        <code>Мин.</code>
                    </Typography>
                </Box>
                <Box mx={.5} mt={1.8}>
                    <code>:</code>
                </Box>
                <Box mr={1} display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                    <Box sx={{
                        px: 2, py: 1,
                        borderRadius: `10px`, background: palette.infoLight
                    }}>
                        <Typography textAlign='center' sx={{ mt: .5, fontSize: '2.2rem', fontWeight: 500 }}>
                            <code>{seconds < 10 ? `0${seconds}` : seconds}</code>
                        </Typography>
                    </Box>
                    <Typography textAlign='center' sx={{ mt: .5, fontSize: '.8rem', fontWeight: 600 }}>
                        <code>Сек.</code>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}

export const ProgramsOfficePage = () => {
    const { data } = useSelector((state: AppState) => state.app);
    const [searchParams] = useSearchParams();
    const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);
    const [positionsArr, setPositionsArr] = useState<any[] | undefined>(undefined);
    const [globalClone, setGlobalClone] = useState<boolean>(false);
    const [errtext, setErrtext] = useState<string>('');
    const [nowProgram, setNowProgram] = useState<Program | undefined>(undefined);
    const [needPaymantBtn, setNeedPaymantBtn] = useState<boolean>(false);
    const [paymantUserStatus, setPaymantUserStatus] = useState<boolean>(true);
    const [levels, setLevels] = useState<any[]>([]);
    const [m_type, setm_type] = useState<number>(2);
    const [listClones, setListClones] = useState<any[] | undefined>(undefined);
    const [listHistory, setListHistory] = useState<any[]>([]);
    const [subscribe, setSubscribe] = useState<{
        subscribe: boolean,
        subscribe_comment: string,
        subscribe_error: boolean,
        subscribe_paid: boolean
    } | undefined>(undefined);
    const [fullData, setFullData] = useState<string>('');
    const [showTimer, setShowTimer] = useState<boolean>(false);

    const programParam = searchParams.get('p');
    const levelParam = searchParams.get('l');
    const mentorParam = searchParams.get('m');

    const dispatch = useDispatch();

    const onSubmit = (data: any) => {
        setErrtext('')
        levelsRequest(data);
    }

    const [levelsData, { isLoading, isError }] = useViewPositionMutation();
    const levelsRequest = async (body: any) => {
        const jwt = localStorage.getItem('jwt');
        await levelsData({ body, jwt })
            .unwrap()
            .then((payload: any) => {
                setFullData(payload);
                setPaymantUserStatus(payload.paymant);
                setGlobalClone(payload.global_clone)
                setPositionsArr(payload.data);
                setLevels(payload.levels);
                setm_type(payload.marketing_type);
                setListClones(payload.list_clones);
                setListHistory(payload.list_histori);

                setSubscribe({
                    subscribe: payload.subscribe,
                    subscribe_comment: payload.subscribe_comment,
                    subscribe_error: payload.subscribe_error,
                    subscribe_paid: payload.subscribe_paid
                });

                if (payload.tester === true && programParam === "6") {
                    dispatch(updActiveTimer({ state: !payload.tester }))
                }
            })
            .catch((error: any) => {
                setLevels(error.data.levels);
                setErrtext(error.data.message);
                updateNeedPaymant(error.data.paymant);
                if (error.data.tester === true && programParam === "6") {
                    dispatch(updActiveTimer({ state: !error.data.tester }))
                }
            })
    }

    const updateNeedPaymant = (status: boolean) => {
        setNeedPaymantBtn(status)
    }

    const updErrText = (text: string) => setErrtext(text);

    const payCloneForPloshadka = (request: any) => {
        Request(request);
    }

    const [reqData, { isLoading: isLd }] = usePayMarketingMutation();
    const Request = async (body: any) => {
        const jwt = localStorage.getItem('jwt');
        await reqData({ body, jwt })
            .unwrap()
            .then((payload: any) => {
                setgetAlert({ type: 1, msg: payload.message });
            })
            .catch((error: any) => {
                setgetAlert({ type: 2, msg: error.data.message });
            })
    }

    // Проверка: нужно ли показывать таймер
    const checkIfShowTimer = (program: Program | undefined): boolean => {
        if (!program || !program.timeStart || data.chosen) {
            return false;
        }

        const startTime = new Date(program.timeStart);
        const now = new Date();

        // Проверяем что время старта валидное и еще не наступило
        return !isNaN(startTime.getTime()) && now < startTime;
    }

    // Callback для скрытия таймера после завершения
    const handleTimerExpire = () => {
        setShowTimer(false);
    }

    useEffect(() => {
        const requestParams = {
            program: programParam,
            level: levelParam,
            mentor_id: mentorParam
        };

        onSubmit(requestParams);

        const program = programs.find((el) => el.id === Number(programParam));
        setNowProgram(program);

        // Проверяем нужно ли показывать таймер
        setShowTimer(checkIfShowTimer(program));

    }, [searchParams, data.chosen]);

    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            {/* Таймер - показываем только если условия выполнены */}
            {showTimer && nowProgram?.timeStart ? (
                <Box sx={{ minHeight: '500px' }}>
                    <Typography
                        variant="h1"
                        textAlign='center'
                        sx={{
                            fontSize: { xs: "30px", sm: '36px', lg: "48px" },
                            mt: { xs: 8, sm: 15, lg: 20 }
                        }}
                    >
                        До СТАРТА платформы осталось:
                    </Typography>
                    <MyTimer
                        key={`timer-${nowProgram.id}-${nowProgram.timeStart}`}
                        expiryTimestamp={new Date(nowProgram.timeStart)}
                        onTimerExpire={handleTimerExpire}
                    />
                </Box>
            ) : (
                <>
                    {isLoading && <SkeletonComp />}

                    {/* всплывающее меню справа */}
                    {!isLoading && <RightDrawer />}

                    {/* цепь структуры */}
                    {!isLoading &&
                        <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' pt={0} pb={0}>
                            <StructureChain arrChain={listHistory} />
                        </Box>
                    }

                    {/* levels */}
                    {!isLoading && <Levels levels={levels} nowProgram={nowProgram} />}

                    {/* успешная загрузка выводим структуру*/}
                    {!isLoading && positionsArr && !isError &&
                        <Structure
                            fullData={fullData}
                            paymantUserStatus={paymantUserStatus}
                            globalClone={globalClone}
                            listHistory={listHistory}
                            subscribe={subscribe}
                            structure={positionsArr}
                            program={nowProgram}
                            marketing_type={m_type}
                            list_clones={listClones ? listClones : []}
                        />
                    }

                    {/* если ошибка при загрузке */}
                    {isError &&
                        <Box height='70vh' width='100%' display='flex' textAlign='center' justifyContent='center' alignItems='center' flexDirection='column'>
                            <Typography variant="h1" color='error' mb={3}>
                                {errtext}
                            </Typography>

                            {needPaymantBtn && (
                                <PaymantContainer
                                    updateNeedPaymant={updateNeedPaymant}
                                    updErrText={updErrText}
                                    paymantData={{
                                        program: Number(programParam),
                                        level: Number(levelParam),
                                        mentor_id: Number(mentorParam)
                                    }}
                                />
                            )}

                            {/* покупка клона на программе 6/100 руб */}
                            {isError && !needPaymantBtn && programParam === "6" && (
                                <Box mt={5}>
                                    <Typography sx={{ mb: 1, fontSize: "16px", fontWeight: 600 }}>
                                        Приобритение дополнительного клона
                                    </Typography>

                                    <Button
                                        disabled={isLd}
                                        fullWidth
                                        onClick={() => payCloneForPloshadka({
                                            program: programParam,
                                            level: levelParam
                                        })}
                                    >
                                        Купить клона ЖО
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    }
                </>
            )}
        </>
    )
}